import axiosInstance from '@/app/api/axiosInstance';
import {
  CommandCenterSearchParams,
  CommandCenterSearchResponse,
} from '@/app/types/commandCenter';

export async function searchCommandCenter(
  params: CommandCenterSearchParams
): Promise<CommandCenterSearchResponse> {
  const response = await axiosInstance.get<CommandCenterSearchResponse>(
    '/command-center/search',
    { params }
  );
  return response.data;
}
